import { KVERNELAND_BORDER_RADIUS, KVERNELAND_BOX_SHADOW, KVERNELAND_COLORS, KVERNELAND_FONTS, KVERNELAND_LAYOUT, KVERNELAND_SPACING, } from './themeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const themeConf = {
    color: {
        primary: {
            lightest: KVERNELAND_COLORS.primary.lightest,
            light: KVERNELAND_COLORS.primary.light,
            main: KVERNELAND_COLORS.primary.main,
            dark: KVERNELAND_COLORS.primary.dark,
            darkest: KVERNELAND_COLORS.primary.darkest,
        },
        brand: {
            lightest: KVERNELAND_COLORS.brand.lightest,
            light: KVERNELAND_COLORS.brand.light,
            main: KVERNELAND_COLORS.brand.main,
            dark: KVERNELAND_COLORS.brand.dark,
            darkest: KVERNELAND_COLORS.brand.darkest,
        },
        success: {
            light: KVERNELAND_COLORS.success.light,
            main: KVERNELAND_COLORS.success.main,
            dark: KVERNELAND_COLORS.success.dark,
        },
        error: {
            lightest: KVERNELAND_COLORS.error.lightest,
            light: KVERNELAND_COLORS.error.light,
            main: KVERNELAND_COLORS.error.main,
            dark: KVERNELAND_COLORS.error.dark,
        },
        warning: {
            lightest: KVERNELAND_COLORS.warning.lightest,
            light: KVERNELAND_COLORS.warning.light,
            main: KVERNELAND_COLORS.warning.main,
        },
        grey: {
            lightest: KVERNELAND_COLORS.grey.lightest,
            light: KVERNELAND_COLORS.grey.light,
            default: KVERNELAND_COLORS.grey.default,
            dark: KVERNELAND_COLORS.grey.dark,
            darkest: KVERNELAND_COLORS.grey.darkest,
        },
        input: {
            placeholder: KVERNELAND_COLORS.grey.default,
            border: KVERNELAND_COLORS.grey.default,
        },
        background: {
            body: KVERNELAND_COLORS.background.body,
            light: KVERNELAND_COLORS.background.light,
            dark: KVERNELAND_COLORS.background.dark,
        },
        font: {
            dark: KVERNELAND_COLORS.font.dark,
            light: KVERNELAND_COLORS.font.light,
        },
        common: {
            contentHover: KVERNELAND_COLORS.common.contentHover,
        },
    },
    font: {
        family: KVERNELAND_FONTS.family,
        size: {
            small: KVERNELAND_FONTS.size.small,
            mediumSmall: KVERNELAND_FONTS.size.mediumSmall,
            medium: KVERNELAND_FONTS.size.medium,
            mediumBig: KVERNELAND_FONTS.size.mediumBig,
            big: KVERNELAND_FONTS.size.big,
            caption: KVERNELAND_FONTS.size.caption,
            title: KVERNELAND_FONTS.size.title,
            heading: KVERNELAND_FONTS.size.heading,
        },
        lineHeight: {
            small: KVERNELAND_FONTS.lineHeight.small,
            mediumSmall: KVERNELAND_FONTS.lineHeight.mediumSmall,
            medium: KVERNELAND_FONTS.lineHeight.medium,
            mediumBig: KVERNELAND_FONTS.lineHeight.mediumBig,
            big: KVERNELAND_FONTS.lineHeight.big,
        },
        weight: {
            light: KVERNELAND_FONTS.weight.light,
            normal: KVERNELAND_FONTS.weight.normal,
            bold: KVERNELAND_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: KVERNELAND_BORDER_RADIUS.low,
            default: KVERNELAND_BORDER_RADIUS.default,
            high: KVERNELAND_BORDER_RADIUS.high,
            onlyTop: KVERNELAND_BORDER_RADIUS.onlyTop,
            onlyRight: KVERNELAND_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: KVERNELAND_BOX_SHADOW.light,
            default: KVERNELAND_BOX_SHADOW.default,
            dark: KVERNELAND_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: KVERNELAND_SPACING.layout.fullWidth,
            partialWidth: KVERNELAND_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: KVERNELAND_SPACING.margin.smallest,
            small: KVERNELAND_SPACING.margin.small,
            default: KVERNELAND_SPACING.margin.default,
            large: KVERNELAND_SPACING.margin.large,
            largest: KVERNELAND_SPACING.margin.largest,
            horizontalDefault: KVERNELAND_SPACING.margin.horizontalDefault,
            verticalDefault: KVERNELAND_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: KVERNELAND_SPACING.padding.smallest,
            small: KVERNELAND_SPACING.padding.small,
            default: KVERNELAND_SPACING.padding.default,
            large: KVERNELAND_SPACING.padding.large,
            largest: KVERNELAND_SPACING.padding.largest,
            horizontalDefault: KVERNELAND_SPACING.padding.horizontalDefault,
            verticalDefault: KVERNELAND_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: KVERNELAND_LAYOUT.width.full,
            partial: KVERNELAND_LAYOUT.width.partial,
        },
        sidebar: {
            full: KVERNELAND_LAYOUT.sidebar.full,
        },
        header: {
            topBar: KVERNELAND_LAYOUT.header.topBar,
            menu: KVERNELAND_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: KVERNELAND_COLORS.brand.main,
                color: KVERNELAND_COLORS.font.light,
            },
            headerSecondary: {
                background: KVERNELAND_COLORS.brand.main,
                color: KVERNELAND_COLORS.font.light,
            },
            th: {
                background: KVERNELAND_COLORS.background.light,
                color: KVERNELAND_COLORS.font.dark,
            },
            row: {
                hover: KVERNELAND_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: KVERNELAND_COLORS.brand.main,
                hover: KVERNELAND_COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: KVERNELAND_COLORS.brand.main,
                text: KVERNELAND_COLORS.font.light,
                menuIcon: KVERNELAND_COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: KVERNELAND_COLORS.background.light,
                text: KVERNELAND_COLORS.font.dark,
                selected: KVERNELAND_COLORS.brand.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: KVERNELAND_COLORS.primary.light,
                headerText: KVERNELAND_COLORS.font.dark,
                buttonBackground: KVERNELAND_COLORS.background.light,
                buttonText: KVERNELAND_COLORS.font.dark,
                buttonBackgroundHover: KVERNELAND_COLORS.primary.main,
                triggerBackground: KVERNELAND_COLORS.background.light,
                triggerText: KVERNELAND_COLORS.brand.main,
                userIconBackground: KVERNELAND_COLORS.primary.darkest,
                userIconText: KVERNELAND_COLORS.font.light,
            },
        },
        tabs: {
            indicator: KVERNELAND_COLORS.background.light,
            background: KVERNELAND_COLORS.brand.main,
            color: KVERNELAND_COLORS.font.light,
        },
        listItem: {
            backgroundHover: KVERNELAND_COLORS.background.light,
            backgroundSelected: KVERNELAND_COLORS.primary.main,
            textHover: KVERNELAND_COLORS.font.dark,
            textSelected: KVERNELAND_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: KVERNELAND_COLORS.brand.main,
                border: KVERNELAND_COLORS.brand.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: KVERNELAND_COLORS.background.light,
                text: KVERNELAND_COLORS.font.dark,
            },
            arrow: {
                background: KVERNELAND_COLORS.background.light,
            },
            rule: {
                iconSuccess: KVERNELAND_COLORS.success.main,
                iconError: KVERNELAND_COLORS.error.main,
                text: KVERNELAND_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: KVERNELAND_COLORS.grey.lightest,
            backgroundHover: KVERNELAND_COLORS.grey.light,
            text: KVERNELAND_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: KVERNELAND_COLORS.primary.light,
                main: KVERNELAND_COLORS.primary.main,
                dark: KVERNELAND_COLORS.primary.dark,
            },
            secondary: {
                light: KVERNELAND_COLORS.brand.light,
                main: KVERNELAND_COLORS.brand.main,
                dark: KVERNELAND_COLORS.brand.dark,
            },
            text: {
                primary: KVERNELAND_COLORS.font.dark,
                secondary: KVERNELAND_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: KVERNELAND_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: KVERNELAND_COLORS.font.dark,
                    fontSize: KVERNELAND_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: KVERNELAND_COLORS.grey.light,
                    '&$disabled': {
                        color: KVERNELAND_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: KVERNELAND_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: KVERNELAND_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: KVERNELAND_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${KVERNELAND_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: KVERNELAND_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: KVERNELAND_COLORS.font.light,
                        fontSize: KVERNELAND_FONTS.size.mediumSmall,
                        fontWeight: KVERNELAND_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${KVERNELAND_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${KVERNELAND_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: KVERNELAND_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: KVERNELAND_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const theme = createMyTheme(themeConf);
//# sourceMappingURL=theme.js.map